module.exports = __webpack_public_path__ + "static/img/question.6479385.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/question.svg
// module id = PfSF
// module chunks = 0